// partnership
export const CLEAR_PARTNERSHIP = "partnership@CLEAR_PARTNERSHIP"
export const FILTER_APPOINTMENT = "partnership@FILTER_APPOINTMENT"

export const FETCH_PARTNERSHIPS_INIT = "partnership@FETCH_PARTNERSHIPS_INIT"
export const FETCH_PARTNERSHIPS_SUCCEDED = "partnership@FETCH_PARTNERSHIPS_SUCCEDED"
export const FETCH_PARTNERSHIPS_FAILED = "partnership@FETCH_PARTNERSHIPS_FAILED"

export const CREATE_PARTNERSHIP_INIT = "partnership@CREATE_PARTNERSHIP_INIT"
export const CREATE_PARTNERSHIP_SUCCEDED = "partnership@CREATE_PARTNERSHIP_SUCCEDED"
export const CREATE_PARTNERSHIP_FAILED = "partnership@CREATE_PARTNERSHIP_FAILED"

export const FETCH_PARTNERSHIP_INIT = "partnership@FETCH_PARTNERSHIP_INIT"
export const FETCH_PARTNERSHIP_SUCCEDED = "partnership@FETCH_PARTNERSHIP_SUCCEDED"
export const FETCH_PARTNERSHIP_FAILED = "partnership@FETCH_PARTNERSHIP_FAILED"

export const EDIT_PARTNERSHIP_INIT = "partnership@EDIT_PARTNERSHIP_INIT"
export const EDIT_PARTNERSHIP_SUCCEDED = "partnership@EDIT_PARTNERSHIP_SUCCEDED"
export const EDIT_PARTNERSHIP_FAILED = "partnership@EDIT_PARTNERSHIP_FAILED"

export const DISABLE_PARTNERSHIP_INIT = "partnership@DISABLE_PARTNERSHIP_INIT"
export const DISABLE_PARTNERSHIP_SUCCEDED = "partnership@DISABLE_PARTNERSHIP_SUCCEDED"
export const DISABLE_PARTNERSHIP_FAILED = "partnership@DISABLE_PARTNERSHIP_FAILED"

export const ENABLE_PARTNERSHIP_INIT = "partnership@ENABLE_PARTNERSHIP_INIT"
export const ENABLE_PARTNERSHIP_SUCCEDED = "partnership@ENABLE_PARTNERSHIP_SUCCEDED"
export const ENABLE_PARTNERSHIP_FAILED = "partnership@ENABLE_PARTNERSHIP_FAILED"

export const DELETE_PARTNERSHIP_INIT = "partnership@DELETE_PARTNERSHIP_INIT"
export const DELETE_PARTNERSHIP_SUCCEDED = "partnership@DELETE_PARTNERSHIP_SUCCEDED"
export const DELETE_PARTNERSHIP_FAILED = "partnership@DELETE_PARTNERSHIP_FAILED"


export const DISABLE_PARTNERSHIPS_INIT = "partnership@DISABLE_PARTNERSHIPS_INIT"
export const DISABLE_PARTNERSHIPS_SUCCEDED = "partnership@DISABLE_PARTNERSHIPS_SUCCEDED"
export const DISABLE_PARTNERSHIPS_FAILED = "partnership@DISABLE_PARTNERSHIPS_FAILED"

export const ENABLE_PARTNERSHIPS_INIT = "partnership@ENABLE_PARTNERSHIPS_INIT"
export const ENABLE_PARTNERSHIPS_SUCCEDED = "partnership@ENABLE_PARTNERSHIPS_SUCCEDED"
export const ENABLE_PARTNERSHIPS_FAILED = "partnership@ENABLE_PARTNERSHIPS_FAILED"

export const FETCH_PARTNERSHIP_CONTENT_INIT = "partnership@FETCH_PARTNERSHIP_CONTENT_INIT"
export const FETCH_PARTNERSHIP_CONTENT_SUCCEDED = "partnership@FETCH_PARTNERSHIP_CONTENT_SUCCEDED"
export const FETCH_PARTNERSHIP_CONTENT_FAILED = "partnership@FETCH_PARTNERSHIP_CONTENT_FAILED"

export const EDIT_PARTNERSHIP_CONTENT_INIT = "partnership@EDIT_PARTNERSHIP_CONTENT_INIT"
export const EDIT_PARTNERSHIP_CONTENT_SUCCEDED = "partnership@EDIT_PARTNERSHIP_CONTENT_SUCCEDED"
export const EDIT_PARTNERSHIP_CONTENT_FAILED = "partnership@EDIT_PARTNERSHIP_CONTENT_FAILED"

export const FETCH_APPOINTMENT_INIT = "partnership@FETCH_APPOINTMENT_INIT"
export const FETCH_APPOINTMENT_SUCCEDED = "partnership@FETCH_APPOINTMENT_SUCCEDED"
export const FETCH_APPOINTMENT_FAILED = "partnership@FETCH_APPOINTMENT_FAILED"

export const FETCH_APPOINTMENTS_INIT = "partnership@FETCH_APPOINTMENTS_INIT"
export const FETCH_APPOINTMENTS_SUCCEDED = "partnership@FETCH_APPOINTMENTS_SUCCEDED"
export const FETCH_APPOINTMENTS_FAILED = "partnership@FETCH_APPOINTMENTS_FAILED"

export const FETCH_AVAILABILITIES_INIT = "partnership@FETCH_AVAILABILITIES_INIT"
export const FETCH_AVAILABILITIES_SUCCEDED = "partnership@FETCH_AVAILABILITIES_SUCCEDED"
export const FETCH_AVAILABILITIES_FAILED = "partnership@FETCH_AVAILABILITIES_FAILED"

export const CREATE_APPOINTMENT_INIT = "partnership@CREATE_APPOINTMENT_INIT"
export const CREATE_APPOINTMENT_SUCCEDED = "partnership@CREATE_APPOINTMENT_SUCCEDED"
export const CREATE_APPOINTMENT_FAILED = "partnership@CREATE_APPOINTMENT_FAILED"

export const EDIT_APPOINTMENT_INIT = "partnership@EDIT_APPOINTMENT_INIT"
export const EDIT_APPOINTMENT_SUCCEDED = "partnership@EDIT_APPOINTMENT_SUCCEDED"
export const EDIT_APPOINTMENT_FAILED = "partnership@EDIT_APPOINTMENT_FAILED"

export const FETCH_PARTNERSHIP_EXTRA_DATA_INIT = "partnership@FETCH_PARTNERSHIP_EXTRA_DATA_INIT"
export const FETCH_PARTNERSHIP_EXTRA_DATA_SUCCEDED = "partnership@FETCH_PARTNERSHIP_EXTRA_DATA_SUCCEDED"
export const FETCH_PARTNERSHIP_EXTRA_DATA_FAILED = "partnership@FETCH_PARTNERSHIP_EXTRA_DATA_FAILED"

export const EDIT_PARTNERSHIP_EXTRA_DATA_INIT = "partnership@EDIT_PARTNERSHIP_EXTRA_DATA_INIT"
export const EDIT_PARTNERSHIP_EXTRA_DATA_SUCCEDED = "partnership@EDIT_PARTNERSHIP_EXTRA_DATA_SUCCEDED"
export const EDIT_PARTNERSHIP_EXTRA_DATA_FAILED = "partnership@EDIT_PARTNERSHIP_EXTRA_DATA_FAILED"

export const CREATE_PARTNERSHIP_EXTRA_DATA_INIT = "partnership@CREATE_PARTNERSHIP_EXTRA_DATA_INIT"
export const CREATE_PARTNERSHIP_EXTRA_DATA_SUCCEDED = "partnership@CREATE_PARTNERSHIP_EXTRA_DATA_SUCCEDED"
export const CREATE_PARTNERSHIP_EXTRA_DATA_FAILED = "partnership@CREATE_PARTNERSHIP_EXTRA_DATA_FAILED"

export const CREATE_PARTNERSHIP_DOCUMENT_SUCCEDED = "partnershipDocument@CREATE_PARTNERSHIP_DOCUMENT_SUCCEDED"
export const EDIT_PARTNERSHIP_DOCUMENT_SUCCEDED = "partnershipDocument@EDIT_PARTNERSHIP_DOCUMENT_SUCCEDED"
export const DELETE_PARTNERSHIP_DOCUMENT_SUCCEDED = "partnershipDocument@DELETE_PARTNERSHIP_DOCUMENT_SUCCEDED"
